export default {
  enabledWorkplaces: 'Povolené pracoviská',
  selectAll: 'Vybrať všetky',
  deselectAll: 'Zrušiť výber všetkých',
};
